module.exports = __webpack_public_path__ + "media/images/VisualisationDashboard-23b84c068ce2bf6f79a5a2a7a392ee5d.svg";